










































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { getEmployeeList, enableOrDisableEmployee } from '@/api/employee'
import { getTitleIntegrityList } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import { encrypt } from '@/utils/crypto'

@Component({
  name: 'Employee',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private input1: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 50
  private tableData = []
  private id = ''
  private status = ''
  private isSearch: boolean = false

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin') || roles.includes('zhangsan')) return true;
    return false;
  }

   private handleTitleClick(row) {
    // console.log(row.id);
      const encryptedId = encrypt(row.id.toString())
      this.$router.push({ path: '/competition/two', query: { titleId: encryptedId, title: row.content } })
  }

  //状态修改
   private statusHandle(row: any) {
    if (row.username === 'admin') {
      return
    }
    this.id = row.id
    this.status = row.status
    this.type = 0
    this.$confirm('确认调整该赛事的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableCompetition({ id: this.id, status: !this.status ? 1 : 0,type: this.type })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('赛事状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  created() {
    this.init()
  }

  // 获取赛事完整度列表
  private async init(isSearch?: boolean) {
    this.isSearch = true
    const params = {
      titleId: this.input1 ? this.input1 : undefined,
      content: this.input ? this.input : undefined,
      type: 2,
    }
    await getTitleIntegrityList(params).then((res) => {
      if (String(res.data.code) === '1') {
          this.tableData = res.data.data
          // console.log(this.tableData)
        }
    })
    .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
  }


  // 新建赛事
  private addCompetitionHandle() {
      this.$router.push({ path: '/competition/add' })
  }

  // 小程序管理
  private smallProgramManageHandle() {
      this.$router.push({ path: '/competition/smallProgramManage' })
  }

  // 客服管理
  private serviceManageHandle() {
      this.$router.push({ path: '/competition/serviceManage' })
  }

  // 赛事管理
  private titleManageHandle() {
      this.$router.push({ path: '/competition/titleManage' })
  }

  // 公告管理
  private noticeManageHandle() {
      this.$router.push({ path: '/competition/noticeManage' })
  }

  // 宣传图管理
  private promotionalImageManageHandle() {
      this.$router.push({ path: '/competition/promotionalImageManage' })
  }

  // 轮播图管理
  private recordingPictureManageHandle() {
      this.$router.push({ path: '/competition/recordingPictureManage' })
  }

  // 奖品详情管理
  private prizeDetailsManageHandle() {
      this.$router.push({ path: '/competition/prizeDetailsManage' })
  }

  // 赛事规则管理
  private eventRulesManageHandle() {
      this.$router.push({ path: '/competition/eventRulesManage' })
  }

  // 赛事介绍管理
  private eventIntroductionManageHandle() {
      this.$router.push({ path: '/competition/eventIntroductionManage' })
  }

  // 选手管理
  private playerManageHandle() {
      this.$router.push({ path: '/competition/playerManage' })
  }

  // 投票记录管理
  private votingRecordsManageHandle() {
      this.$router.push({ path: '/competition/votingRecordsManage' })
  }

  // 礼物管理
  private giftManageHandle() {
      this.$router.push({ path: '/competition/giftManage' })
  }

  // 赛事直播管理
  private liveStreamingManageHandle() {
      this.$router.push({ path: '/competition/liveStreamingManage' })
  }

  // 开屏管理
  private userOpenManageHandle() {
      this.$router.push({ path: '/competition/userOpenManage' })
  }


  // 喔图管理
  private openManageHandle() {
      this.$router.push({ path: '/competition/openManage' })
  }
}
